import { Loader2 } from "lucide-react";

export function LoadingState({ label = "Cargando datos..." }) {
  return (
    <div data-testid="loading-state" className="loading-state">
      <Loader2 className="h-5 w-5 animate-spin" />
      {label}
    </div>
  );
}
